import { IconButton, InputAdornment, WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import grey from '@material-ui/core/colors/grey';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import AttachmentIcon from '@material-ui/icons/Attachment';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import {
	IActResultApplication,
	IActResultSelect,
	IScores,
	setActResultApplicationData,
	showActResultApplicationDialog,
} from '../actions/imstat';
import { IMessage } from '../actions/message';
import CustomDatePicker from '../components/CustomDatePicker';
import MessageDialog from '../components/MessageDialog';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory, {
	IFetchActResultApplicationDataParam,
	ISaveActResultApplicationParam,
} from '../scenario/ImstatScenarioFactory';
import Config from '../site.config.json';
import InputCheck from '../utils/InputCheck';
import { isMobile } from '../utils/MobileCheck';
const styles = (theme: Theme) =>
	createStyles({
		button: {
			margin: '10px',
		},
		cellItemName: {
			backgroundColor: grey[300],
			minWidth: '150px',
			textAlign: 'right',
			width: '20%',
		},
		cellItemValue: {
			textAlign: 'left',
			width: '80%',
		},
		column: {
			display: 'inline-block',
			textAlign: 'center',
			width: '33.33%',
		},
		flex: {
			flex: 1,
		},
		mobileCellItemName: {
			alignItems: 'center',
			backgroundColor: grey[300],
			display: 'flex',
			minHeight: '40px',
			minWidth: '10px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileCellItemValue: {
			alignItems: 'center',
			display: 'flex',
			minHeight: '40px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileTable: {
			minWidth: '100px',
		},
		paper: {
			minWidth: '700px',
		},
		root: {
			flexGrow: 1,
			padding: 18,
			wordBreak: 'break-all',
		},
		tableLayout: {
			tableLayout: 'fixed',
		},
		textArea: {
			width: '100%',
		},
		whiteSpace: {
			whiteSpace: 'normal',
		},
		whiteSpaceMenuItem: {
			whiteSpace: 'normal',
			wordBreak: 'break-all',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IRouteParams {
	career_id: string;
	class_id: string;
	nittei_only_flg: string;
}

interface IRouteState {
	skillViewFlg: boolean;
	caller: Parameters<IProps['pushHistory']>[0];
}

interface IState {
	careerID: string;
	classID: string;
	nitteiOnlyFlg: boolean;
	openErrorMessageDialog: boolean;
	messages: IMessage[];
	uploadFileName: string;
	skillViewFlg: boolean;
}

/**
 * 実績申請変更
 */
class ImstatActResultApplication extends React.Component<IProps, IState> {
	protected uploadForm: HTMLFormElement | null;
	protected uploadInput: HTMLInputElement | null;
	public constructor(props: IProps) {
		super(props);

		this.state = {
			careerID: '',
			classID: '',
			messages: [],
			nitteiOnlyFlg: false,
			openErrorMessageDialog: false,
			skillViewFlg: false,
			uploadFileName: i18n.t('ActResultApplication_0001'),
		};

		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
		this.onSaveDialogClose = this.onSaveDialogClose.bind(this);
		this.onDialogOk = this.onDialogOk.bind(this);
		this.onChangeSelect = this.onChangeSelect.bind(this);
		this.onChangeInput = this.onChangeInput.bind(this);
		this.changeDate = this.changeDate.bind(this);
		this.onChangeNitteiCheckbox = this.onChangeNitteiCheckbox.bind(this);
		this.commit = this.commit.bind(this);
		this.save = this.save.bind(this);
		this.reset = this.reset.bind(this);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const skillViewFlg = this.props.location.state.skillViewFlg;

		const careerID = this.props.match.params.career_id;
		const classID = this.props.match.params.class_id;
		const nitteiOnlyFlg =
			this.props.match.params.nittei_only_flg === '1' ? true : false;
		this.setState({
			careerID,
			classID,
			nitteiOnlyFlg,
			skillViewFlg,
		});

		// データ取得処理
		this.props.fetchActResultApplicationData(this.props.token, {
			careerID,
			classID,
			nitteiOnlyFlg,
			userAttr: this.props.userAttr,
		});
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		this.props.setActResultApplicationData({});
	}

	/**
	 * 日程フォーマット
	 * @param date 対象日時
	 */
	public getNitteiString(date: any) {
		if (date && date.indexOf('～') !== -1) {
			date = date.replace(
				'～',
				i18n.t('～', {
					ns: 'force',
				})
			);
		}
		return date;
	}

	public render() {
		const { classes, data } = this.props;
		const { skillViewFlg } = this.state;
		const showApprovers = data.approve1List || data.approve2List;

		const startDate = data.startDate ? data.startDate : '';
		const endDate = data.endDate ? data.endDate : '';
		const validDate = data.validDate ? data.validDate : '';

		return (
			<div className={classes.root}>
				<div className={classes.wrapDiv}>
					{!isMobile() && (
						<Paper className={classes.paper}>
							<Table className={this.props.classes.tableLayout}>
								<TableBody>
									<TableRow>
										<TableCell
											className={classes.cellItemName}
										>
											{i18n.t(
												'ActResultApplication_0002'
											)}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
										>
											{data.managementCode}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell
											className={classes.cellItemName}
										>
											{skillViewFlg
												? i18n.t(
														'ActResultApplication_0003'
												  )
												: i18n.t(
														'ActResultApplication_0004'
												  )}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
										>
											{data.careerTitle}
										</TableCell>
									</TableRow>
									{skillViewFlg && (
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ActResultApplication_0005'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{data.skillType
													? i18n.t(data.skillType, {
															ns: 'force',
													  })
													: ''}
											</TableCell>
										</TableRow>
									)}
									<TableRow>
										<TableCell
											className={classes.cellItemName}
										>
											{skillViewFlg
												? i18n.t(
														'ActResultApplication_0006'
												  )
												: i18n.t(
														'ActResultApplication_0007'
												  )}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
										>
											{data.classList &&
												i18n.t(
													data.classList[0].objName,
													{
														ns: 'force',
													}
												)}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell
											className={classes.cellItemName}
										>
											{skillViewFlg
												? i18n.t(
														'ActResultApplication_0008'
												  )
												: i18n.t(
														'ActResultApplication_0009'
												  )}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
										>
											<Select
												id="sel_Endresult"
												input={
													<Input
														name="sel_Endresult"
														id="sel_Endresult"
													/>
												}
												autoWidth={true}
												onChange={this.onChangeSelect}
												value={data.sel_Endresult}
											>
												<MenuItem value="1">
													{skillViewFlg
														? i18n.t(
																'ActResultApplication_0010'
														  )
														: i18n.t(
																'ActResultApplication_0011'
														  )}
												</MenuItem>
												<MenuItem value="2">
													{skillViewFlg
														? i18n.t(
																'ActResultApplication_0012'
														  )
														: i18n.t(
																'ActResultApplication_0013'
														  )}
												</MenuItem>
											</Select>
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell
											className={classes.cellItemName}
										>
											{skillViewFlg
												? i18n.t(
														'ActResultApplication_0014'
												  )
												: i18n.t(
														'ActResultApplication_0008'
												  )}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
										>
											<Select
												id="sel_Status"
												input={
													<Input
														name="sel_Status"
														id="sel_Status"
													/>
												}
												autoWidth={true}
												onChange={this.onChangeSelect}
												value={data.sel_Status}
											>
												{this.getStatusItem()}
											</Select>
										</TableCell>
									</TableRow>
									{!skillViewFlg && (
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ActResultApplication_0015'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												<CustomDatePicker
													name="startDate"
													value={startDate}
													onChange={this.changeDate}
												/>
											</TableCell>
										</TableRow>
									)}
									<TableRow>
										<TableCell
											className={classes.cellItemName}
										>
											{skillViewFlg
												? i18n.t(
														'ActResultApplication_0016'
												  )
												: i18n.t(
														'ActResultApplication_0017'
												  )}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
										>
											<CustomDatePicker
												name="endDate"
												value={endDate}
												onChange={this.changeDate}
											/>
										</TableCell>
									</TableRow>
									{!skillViewFlg && (
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ActResultApplication_0018'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												<CustomDatePicker
													name="validDate"
													value={validDate}
													onChange={this.changeDate}
													disabled={
														data.validationType ===
														2
															? false
															: true
													}
												/>
											</TableCell>
										</TableRow>
									)}
									{skillViewFlg && data.validationType !== 0 && (
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ActResultApplication_0018'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												<CustomDatePicker
													name="validDate"
													value={validDate}
													onChange={this.changeDate}
													disabled={
														data.validationType ===
														2
															? false
															: true
													}
												/>
											</TableCell>
										</TableRow>
									)}
									{!skillViewFlg && (
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ActResultApplication_0019'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{data.dateList &&
													data.dateList.map(
														(
															nittei: IActResultSelect,
															i: number
														): JSX.Element => (
															<FormControlLabel
																control={
																	<Checkbox
																		id={String(
																			i
																		)}
																		checked={
																			nittei.selected
																		}
																		value={
																			nittei.scheduleId
																		}
																		color="primary"
																		onChange={
																			this
																				.onChangeNitteiCheckbox
																		}
																	/>
																}
																label={this.getNitteiString(
																	nittei.nitteiString
																)}
															/>
														)
													)}
											</TableCell>
										</TableRow>
									)}
									{!skillViewFlg && (
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ActResultApplication_0020'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												<TextField
													id="score"
													value={data.score || ''}
													onChange={
														this.onChangeInput
													}
												/>
											</TableCell>
										</TableRow>
									)}
									{skillViewFlg &&
										data.scoreRegisterFlag === '1' && (
											<TableRow>
												<TableCell
													className={
														classes.cellItemName
													}
												>
													{i18n.t(
														'ActResultApplication_0020'
													)}
												</TableCell>
												<TableCell
													className={
														classes.cellItemValue
													}
												>
													<TextField
														id="score"
														value={data.score || ''}
														onChange={
															this.onChangeInput
														}
														disabled={
															data.sel_Endresult ===
															'1'
														}
													/>
												</TableCell>
											</TableRow>
										)}
									{skillViewFlg &&
										data.scoreItemsRegisterFlag &&
										data.scoresList &&
										data.scoresList.map((ele, index) => {
											return (
												<TableRow key={index}>
													<TableCell
														className={
															classes.cellItemName
														}
													>
														{i18n.t(
															'ActResultApplication_0021'
														)}
														{index + 1}
													</TableCell>
													<TableCell
														className={
															classes.cellItemValue
														}
													>
														<Grid
															container={true}
															spacing={4}
														>
															<Grid item={true}>
																<TextField
																	id="scoreName"
																	value={
																		ele.scoreName
																	}
																	disabled={
																		true
																	}
																/>
															</Grid>
															<Grid item={true}>
																<TextField
																	id={
																		ele.scoreID
																	}
																	value={
																		ele.scores
																	}
																	onChange={this.onChangeScoresInput.bind(
																		this
																	)}
																	disabled={
																		data.sel_Endresult ===
																		'1'
																	}
																/>
															</Grid>
														</Grid>
													</TableCell>
												</TableRow>
											);
										})}
									{!skillViewFlg && (
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ActResultApplication_0022'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												<TextField
													id="studentCareerCode"
													value={
														data.studentCareerCode ||
														''
													}
													onChange={
														this.onChangeInput
													}
												/>
											</TableCell>
										</TableRow>
									)}
									{skillViewFlg && (
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{data.certificationFlg === '1'
													? i18n.t(
															'ActResultApplication_0023'
													  )
													: i18n.t(
															'ActResultApplication_0022'
													  )}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												<Grid
													container={true}
													spacing={4}
												>
													<Grid item={true}>
														<TextField
															id="studentCareerCode"
															value={
																data.studentCareerCode ||
																''
															}
															onChange={
																this
																	.onChangeInput
															}
															label={i18n.t(
																'ActResultApplication_0024'
															)}
															disabled={
																data.sel_Endresult ===
																'1'
															}
														/>
													</Grid>
													{data.certificationFlg ===
														'1' && (
														<Grid
															item={true}
															style={{
																marginTop:
																	'15px',
															}}
														>
															<Input
																type="text"
																value={
																	data.certificationFileName
																		? data.certificationFileName
																		: this
																				.state
																				.uploadFileName
																}
																disabled={true}
																fullWidth={
																	false
																}
																endAdornment={
																	<InputAdornment position="end">
																		<IconButton
																			onClick={
																				this
																					.handleClickAttachment
																			}
																			disabled={
																				data.sel_Endresult ===
																				'1'
																			}
																		>
																			<AttachmentIcon />
																		</IconButton>
																	</InputAdornment>
																}
															/>
															<form
																method="POST"
																encType="multipart/form-data"
																action={
																	Config.tsqPath +
																	'/tsq/ui/common/resources/rest/file/upload'
																}
																ref={form =>
																	(this.uploadForm = form)
																}
															>
																<input
																	type="file"
																	name="uploadFile"
																	onChange={
																		this
																			.handleSelectFile
																	}
																	ref={input =>
																		(this.uploadInput = input)
																	}
																	style={{
																		display:
																			'none',
																	}}
																/>
															</form>
														</Grid>
													)}
												</Grid>
											</TableCell>
										</TableRow>
									)}
									<TableRow>
										<TableCell
											className={classes.cellItemName}
										>
											{i18n.t(
												'ActResultApplication_0027'
											)}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
										>
											<TextField
												id="comment"
												value={data.comment || ''}
												onChange={this.onChangeInput}
											/>
											{skillViewFlg
												? i18n.t(
														'ActResultApplication_0025'
												  )
												: i18n.t(
														'ActResultApplication_0026'
												  )}
										</TableCell>
									</TableRow>
									{showApprovers && (
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ActResultApplication_0028'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{data.approve1List && (
													<div>
														<InputLabel htmlFor="acceptManagerUserID">
															{i18n.t(
																'ActResultApplication_0029'
															)}
														</InputLabel>
														<Select
															id="approverId1"
															input={
																<Input
																	name="acceptManagerUserID"
																	id="acceptManagerUserID"
																/>
															}
															autoWidth={true}
															onChange={
																this
																	.onChangeSelect
															}
															value={
																data.acceptManagerUserID
															}
															displayEmpty={true}
															classes={{
																selectMenu: this
																	.props
																	.classes
																	.whiteSpace,
															}}
														>
															{data.approve1List.map(
																(
																	approver: any,
																	i: number
																): JSX.Element => (
																	<MenuItem
																		key={i}
																		value={
																			approver.userId
																		}
																		className={
																			this
																				.props
																				.classes
																				.whiteSpaceMenuItem
																		}
																	>
																		{i18n.t(
																			approver.approverOptionString,
																			{
																				ns:
																					'force',
																			}
																		)}
																	</MenuItem>
																)
															)}
														</Select>
													</div>
												)}
												{data.approve2List && (
													<div>
														<InputLabel htmlFor="acceptManagerUserID">
															{i18n.t(
																'ActResultApplication_0030'
															)}
														</InputLabel>
														<Select
															id="approverId2"
															input={
																<Input
																	name="acceptManagerUserID2"
																	id="acceptManagerUserID2"
																/>
															}
															autoWidth={true}
															onChange={
																this
																	.onChangeSelect
															}
															value={
																data.acceptManagerUserID2
															}
															displayEmpty={true}
															classes={{
																selectMenu: this
																	.props
																	.classes
																	.whiteSpace,
															}}
														>
															{data.approve2List.map(
																(
																	approver: any,
																	i: number
																): JSX.Element => (
																	<MenuItem
																		key={i}
																		value={
																			approver.userId
																		}
																		className={
																			this
																				.props
																				.classes
																				.whiteSpaceMenuItem
																		}
																	>
																		{i18n.t(
																			approver.approverOptionString,
																			{
																				ns:
																					'force',
																			}
																		)}
																	</MenuItem>
																)
															)}
														</Select>
													</div>
												)}
											</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</Paper>
					)}
					{isMobile() && (
						<Paper>
							<div className={classes.mobileTable}>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ActResultApplication_0002')}
								</div>
								<div className={classes.mobileCellItemValue}>
									{data.managementCode}
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ActResultApplication_0004')}
								</div>
								<div className={classes.mobileCellItemValue}>
									{data.careerTitle}
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ActResultApplication_0007')}
								</div>
								<div className={classes.mobileCellItemValue}>
									{data.classList &&
										i18n.t(data.classList[0].objName, {
											ns: 'force',
										})}
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ActResultApplication_0009')}
								</div>
								<div className={classes.mobileCellItemValue}>
									<Select
										id="sel_Endresult"
										input={
											<Input
												name="sel_Endresult"
												id="sel_Endresult"
											/>
										}
										autoWidth={true}
										onChange={this.onChangeSelect}
										value={data.sel_Endresult}
									>
										<MenuItem value="1">
											{i18n.t(
												'ActResultApplication_0011'
											)}
										</MenuItem>
										<MenuItem value="2">
											{i18n.t(
												'ActResultApplication_0013'
											)}
										</MenuItem>
									</Select>
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ActResultApplication_0008')}
								</div>
								<div className={classes.mobileCellItemValue}>
									<Select
										id="sel_Status"
										input={
											<Input
												name="sel_Status"
												id="sel_Status"
											/>
										}
										autoWidth={true}
										onChange={this.onChangeSelect}
										value={data.sel_Status}
									>
										{this.getStatusItem()}
									</Select>
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ActResultApplication_0015')}
								</div>
								<div className={classes.mobileCellItemValue}>
									<CustomDatePicker
										name="startDate"
										value={startDate}
										onChange={this.changeDate}
									/>
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ActResultApplication_0017')}
								</div>
								<div className={classes.mobileCellItemValue}>
									<CustomDatePicker
										name="endDate"
										value={endDate}
										onChange={this.changeDate}
									/>
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ActResultApplication_0018')}
								</div>
								<div className={classes.mobileCellItemValue}>
									<CustomDatePicker
										name="validDate"
										value={validDate}
										onChange={this.changeDate}
										disabled={
											data.validationType === 2
												? false
												: true
										}
									/>
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ActResultApplication_0019')}
								</div>
								<div className={classes.mobileCellItemValue}>
									{data.dateList &&
										data.dateList.map(
											(
												nittei: IActResultSelect,
												i: number
											): JSX.Element => (
												<FormControlLabel
													control={
														<Checkbox
															id={String(i)}
															checked={
																nittei.selected
															}
															value={
																nittei.scheduleId
															}
															color="primary"
															onChange={
																this
																	.onChangeNitteiCheckbox
															}
														/>
													}
													label={this.getNitteiString(
														nittei.nitteiString
													)}
												/>
											)
										)}
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ActResultApplication_0020')}
								</div>
								<div className={classes.mobileCellItemValue}>
									<TextField
										id="score"
										value={data.score || ''}
										onChange={this.onChangeInput}
									/>
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ActResultApplication_0022')}
								</div>
								<div className={classes.mobileCellItemValue}>
									<TextField
										id="studentCareerCode"
										value={data.studentCareerCode || ''}
										onChange={this.onChangeInput}
									/>
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('ActResultApplication_0027')}
								</div>
								<div
									className={classes.mobileCellItemValue}
									style={{
										alignItems: 'flex-start',
										flexDirection: 'column',
									}}
								>
									<TextField
										id="comment"
										value={data.comment || ''}
										onChange={this.onChangeInput}
									/>
									{i18n.t('ActResultApplication_0026')}
								</div>
								{showApprovers && (
									<>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t(
												'ActResultApplication_0028'
											)}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
											style={{
												alignItems: 'flex-start',
												flexDirection: 'column',
											}}
										>
											{data.approve1List && (
												<div>
													<InputLabel htmlFor="acceptManagerUserID">
														{i18n.t(
															'ActResultApplication_0029'
														)}
													</InputLabel>
													<Select
														id="approverId1"
														input={
															<Input
																name="acceptManagerUserID"
																id="acceptManagerUserID"
															/>
														}
														autoWidth={true}
														onChange={
															this.onChangeSelect
														}
														value={
															data.acceptManagerUserID
														}
														displayEmpty={true}
														classes={{
															selectMenu: this
																.props.classes
																.whiteSpace,
														}}
													>
														{data.approve1List.map(
															(
																approver: any,
																i: number
															): JSX.Element => (
																<MenuItem
																	key={i}
																	value={
																		approver.userId
																	}
																	className={
																		this
																			.props
																			.classes
																			.whiteSpaceMenuItem
																	}
																>
																	{i18n.t(
																		approver.approverOptionString,
																		{
																			ns:
																				'force',
																		}
																	)}
																</MenuItem>
															)
														)}
													</Select>
												</div>
											)}
											{data.approve2List && (
												<div>
													<InputLabel htmlFor="acceptManagerUserID">
														{i18n.t(
															'ActResultApplication_0030'
														)}
													</InputLabel>
													<Select
														id="approverId2"
														input={
															<Input
																name="acceptManagerUserID2"
																id="acceptManagerUserID2"
															/>
														}
														autoWidth={true}
														onChange={
															this.onChangeSelect
														}
														value={
															data.acceptManagerUserID2
														}
														displayEmpty={true}
														classes={{
															selectMenu: this
																.props.classes
																.whiteSpace,
														}}
													>
														{data.approve2List.map(
															(
																approver: any,
																i: number
															): JSX.Element => (
																<MenuItem
																	key={i}
																	value={
																		approver.userId
																	}
																	className={
																		this
																			.props
																			.classes
																			.whiteSpaceMenuItem
																	}
																>
																	{i18n.t(
																		approver.approverOptionString,
																		{
																			ns:
																				'force',
																		}
																	)}
																</MenuItem>
															)
														)}
													</Select>
												</div>
											)}
										</div>
									</>
								)}
							</div>
						</Paper>
					)}
				</div>
				<>
					<Grid container={true} justify={'center'} spacing={3}>
						<Grid item={true}>
							<Button
								variant="contained"
								color="primary"
								onClick={this.commit}
							>
								{skillViewFlg
									? i18n.t('ActResultApplication_0031')
									: i18n.t('ActResultApplication_0032')}
							</Button>
						</Grid>
						<Grid item={true}>
							<Button
								variant="contained"
								color="primary"
								onClick={this.save}
							>
								{skillViewFlg
									? i18n.t('ActResultApplication_0033')
									: i18n.t('ActResultApplication_0034')}
							</Button>
						</Grid>
						<Grid item={true}>
							<Button
								variant="contained"
								color="default"
								onClick={this.reset}
							>
								{i18n.t('ActResultApplication_0035')}
							</Button>
						</Grid>
					</Grid>
				</>
				<MessageDialog
					open={this.props.openSaveSuccessDialog}
					showCancelButton={false}
					title={i18n.t('ActResultApplication_0036')}
					contents={[{ content: 'LMCM_I_00465' }]}
					onClose={this.onSaveDialogClose}
					onClickOk={this.onSaveDialogClose}
				/>
				<MessageDialog
					open={this.props.openApplySuccessDialog}
					showCancelButton={false}
					title={i18n.t('ActResultApplication_0036')}
					contents={[{ content: 'LMCM_I_00252' }]}
					onClose={this.onDialogOk}
					onClickOk={this.onDialogOk}
				/>
				<MessageDialog
					open={this.state.openErrorMessageDialog}
					showCancelButton={false}
					title={i18n.t('ActResultApplication_0037')}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
			</div>
		);
	}

	/**
	 * ステータス項目取得
	 */
	protected getStatusItem() {
		const { sel_Endresult } = this.props.data;
		const { skillViewFlg } = this.state;
		const itemList: JSX.Element[] = [];
		if (sel_Endresult === '1') {
			if (skillViewFlg) {
				itemList.push(<MenuItem value="0">---</MenuItem>);
				itemList.push(
					<MenuItem value="4">
						{i18n.t('ActResultApplication_0038')}
					</MenuItem>
				);
				itemList.push(
					<MenuItem value="5">
						{i18n.t('ActResultApplication_0039')}
					</MenuItem>
				);
			} else {
				itemList.push(<MenuItem value="0">---</MenuItem>);
				itemList.push(
					<MenuItem value="4">
						{i18n.t('ActResultApplication_0038')}
					</MenuItem>
				);
				itemList.push(
					<MenuItem value="5">
						{i18n.t('ActResultApplication_0040')}
					</MenuItem>
				);
			}
		} else if (sel_Endresult === '2') {
			if (skillViewFlg) {
				itemList.push(<MenuItem value="0">---</MenuItem>);
				itemList.push(
					<MenuItem value="1">
						{i18n.t('ActResultApplication_0041')}
					</MenuItem>
				);
				itemList.push(
					<MenuItem value="2">
						{i18n.t('ActResultApplication_0042')}
					</MenuItem>
				);
			} else {
				itemList.push(<MenuItem value="0">---</MenuItem>);
				itemList.push(
					<MenuItem value="1">
						{i18n.t('ActResultApplication_0041')}
					</MenuItem>
				);
				itemList.push(
					<MenuItem value="2">
						{i18n.t('ActResultApplication_0043')}
					</MenuItem>
				);
				itemList.push(
					<MenuItem value="3">
						{i18n.t('ActResultApplication_0044')}
					</MenuItem>
				);
			}
		}

		return itemList;
	}

	// 添付ボタン押下時ハンドラ
	protected handleClickAttachment = () => {
		if (!this.uploadInput) {
			return;
		}
		this.uploadInput.click();
	};

	// ファイル選択時のハンドラ
	protected handleSelectFile = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		if (!target.files || target.files.length === 0) {
			return;
		}
		const uploadFile = target.files[0];
		const uploadFileName = uploadFile.name;
		const { data } = this.props;
		const newData = Object.assign({}, data);
		newData.certificationNewFile = uploadFile;
		newData.certificationFileName = uploadFileName;
		this.props.setActResultApplicationData(newData);
	};

	/**
	 * エラーメッセージクローズ
	 */
	protected errorMessageDialogClose() {
		this.setState({ openErrorMessageDialog: false, messages: [] });
	}

	/**
	 * メッセージダイアログのみクローズ
	 */
	protected onSaveDialogClose() {
		this.props.onClose();
	}

	/**
	 * メッセージダイアログと実績申請変更画面をクローズ
	 */
	protected onDialogOk() {
		this.props.onClose();
		this.props.pushHistory(this.props.location.state.caller);
	}

	/**
	 * プルダウン変更処理
	 * @param event イベントオブジェクト
	 */
	protected onChangeSelect(event: React.ChangeEvent<HTMLSelectElement>) {
		const { data } = this.props;
		const { name, value } = event.target;
		const newData = Object.assign({}, data);
		newData[name] = value;
		if (name === 'sel_Endresult') {
			// 修了認定が変更された場合はステータスを0に設定
			newData.sel_Status = '0';
		}
		this.props.setActResultApplicationData(newData);
	}

	/**
	 * テキスト変更処理
	 * @param event イベントオブジェクト
	 */
	protected onChangeInput(
		event: React.ChangeEvent<HTMLInputElement>,
		value?: any
	) {
		const target = event.target as HTMLInputElement;
		const { data } = this.props;
		const newData = Object.assign({}, data);
		const val = value !== undefined ? value : target.value;

		if (target.id && target.id !== '') {
			newData[target.id] = val;
		} else {
			newData[target.name] = val;
		}

		this.props.setActResultApplicationData(newData);
	}

	/**
	 * 得点内訳変更処理
	 * @param event イベントオブジェクト
	 */
	protected onChangeScoresInput(event: any, value?: any) {
		const target = event.target as HTMLInputElement;
		const { data } = this.props;
		const newData = JSON.parse(JSON.stringify(data));
		const val = target.value === undefined ? value : target.value;

		const scoresList = JSON.parse(JSON.stringify(newData.scoresList));
		if (
			target.id &&
			target.id !== '' &&
			scoresList &&
			scoresList.length > 0 &&
			val !== value
		) {
			for (const ele of scoresList) {
				if (ele.scoreID === target.id) {
					ele.scores = val;
				}
			}
			const listscores: string[] = [];
			const listscoresID: string[] = [];
			for (const ele of scoresList) {
				if (ele.scores) {
					listscores.push(ele.scores);
					listscoresID.push(ele.scoreID);
				}
			}
			newData.scores = listscores.toString();
			newData.scoresID = listscoresID.toString();
			newData['scoresList'] = scoresList;
		}

		this.props.setActResultApplicationData(newData);
	}

	/**
	 * 日付変更処理
	 * @param name プロパティ名
	 * @param dateStr 日付
	 */
	protected changeDate(name: string, dateStr: string) {
		const { data } = this.props;
		const newData = Object.assign({}, data);
		if (dateStr !== '' && name === 'startDate') {
			newData[name] = dateStr + ' ' + '00:00';
		} else if (
			dateStr !== '' &&
			(name === 'endDate' || name === 'validDate')
		) {
			newData[name] = dateStr + ' ' + '23:59';
		} else {
			newData[name] = dateStr;
		}

		this.props.setActResultApplicationData(newData);
	}

	/**
	 * 日程チェックボックス変更処理
	 * @param event イベントオブジェクト
	 */
	protected onChangeNitteiCheckbox(
		event: React.FormEvent<HTMLInputElement>,
		value?: any
	) {
		const target = event.target as HTMLInputElement;
		const { data } = this.props;
		const newData = Object.assign({}, data);
		const val = value !== undefined ? value : target.value;

		if (target.id && target.id !== '' && newData.dateList) {
			newData.dateList[target.id].selected = val;
		}

		this.props.setActResultApplicationData(newData);
	}

	/**
	 * 入力チェック
	 * @param applyFlg 申請フラグ
	 * @returns true: OK、false: NG
	 */
	protected check(applyFlg: boolean): boolean {
		const { data } = this.props;
		const messages: IMessage[] = [];
		const { skillViewFlg } = this.state;
		// 入力チェック
		if ((skillViewFlg && data.sel_Endresult === '2') || !skillViewFlg) {
			// 得点
			if (!InputCheck.IsNumberOrBlank(data.score)) {
				const message: IMessage = {
					content: 'CHK_E_0033',
					replacements: [
						i18n.t('ActResultApplication_0045'),
						i18n.t('ActResultApplication_0046'),
					],
				};
				messages.push(message);
			}
			// 得点内訳N
			if (data.scoresList && skillViewFlg) {
				data.scoresList.forEach((ele, index) => {
					if (!InputCheck.IsNumberOrBlank(ele.scores)) {
						const message: IMessage = {
							content: 'CHK_E_0033',
							replacements: [
								'「' +
									i18n.t('ActResultApplication_0021') +
									(index + 1) +
									'」',
								i18n.t('ActResultApplication_0046'),
							],
						};
						messages.push(message);
					}
				});
			}
		}
		// 開始日、修了日(認定日)
		if (applyFlg) {
			const errCol: string[] = [];
			if (!skillViewFlg) {
				if (!data.startDate || data.startDate.length === 0) {
					errCol.push(i18n.t('ActResultApplication_0015'));
				}
				if (!data.endDate || data.endDate.length === 0) {
					errCol.push(i18n.t('ActResultApplication_0017'));
				}
			} else {
				if (!data.endDate || data.endDate.length === 0) {
					errCol.push(i18n.t('ActResultApplication_0016'));
				}
			}
			if (errCol.length > 0) {
				const message: IMessage = {
					content: 'CHK_E_0001',
					replacements: [InputCheck.makeErrColListString(errCol)],
				};
				messages.push(message);
			}
		}
		// 有効日時
		{
			const errCol: string[] = [];
			if (
				data.startDate &&
				InputCheck.chkErYYYYMMDDhhmm(
					InputCheck.convertDate(data.startDate)
				)
			) {
				errCol.push(i18n.t('ActResultApplication_0015'));
			}
			if (
				data.endDate &&
				InputCheck.chkErYYYYMMDDhhmm(
					InputCheck.convertDate(data.endDate)
				)
			) {
				if (!skillViewFlg) {
					errCol.push(i18n.t('ActResultApplication_0017'));
				} else {
					errCol.push(i18n.t('ActResultApplication_0016'));
				}
			}
			if (
				data.validDate &&
				InputCheck.chkErYYYYMMDDhhmm(
					InputCheck.convertDate(data.validDate)
				)
			) {
				errCol.push(i18n.t('ActResultApplication_0018'));
			}
			if (errCol.length > 0) {
				const message: IMessage = {
					content: 'CHK_E_0018',
					replacements: [InputCheck.makeErrColListString(errCol)],
				};
				messages.push(message);
			}
		}
		// 日時前後チェック
		if (applyFlg && !skillViewFlg) {
			if (
				data.startDate &&
				!InputCheck.chkErYYYYMMDDhhmm(
					InputCheck.convertDate(data.startDate)
				) &&
				data.endDate &&
				!InputCheck.chkErYYYYMMDDhhmm(
					InputCheck.convertDate(data.endDate)
				)
			) {
				if (
					InputCheck.chkFuturePast(data.startDate, data.endDate) === 1
				) {
					const message: IMessage = {
						content: 'CHK_E_0016',
						replacements: [
							i18n.t('ActResultApplication_0017'),
							i18n.t('ActResultApplication_0015'),
						],
					};
					messages.push(message);
				}
			}
		}
		// 数値最大値チェック
		if ((skillViewFlg && data.sel_Endresult === '2') || !skillViewFlg) {
			if (!InputCheck.IsIntLessMaxOrBlank(data.score)) {
				const message: IMessage = {
					content: 'CHK_E_0014',
					replacements: [
						i18n.t('ActResultApplication_0020'),
						'2147483647',
					],
				};
				messages.push(message);
			}
		}

		if (
			skillViewFlg &&
			data.certificationFlg === '1' &&
			data.sel_Endresult === '2'
		) {
			if (
				data.certificationNewFile &&
				data.certificationFileName &&
				data.certificationNewFile.size === 0
			) {
				const message: IMessage = {
					content: 'LMCM_E_00047',
					replacements: [],
				};
				messages.push(message);
			}

			if (
				data.certificationNewFile &&
				data.certificationFileName &&
				!/\.(pdf|jpg|jpeg|jpe|png)$/i.test(
					data.certificationFileName.toLowerCase()
				)
			) {
				const message: IMessage = {
					content: 'LMCM_E_15203',
					replacements: [],
				};
				messages.push(message);
			}

			if (
				data.certificationNewFile &&
				data.certificationFileName &&
				data.certificationFileName.length > 128
			) {
				const message: IMessage = {
					content: 'LMCM_E_15204',
					replacements: ['128'],
				};
				messages.push(message);
			}
		}
		if (data.scoresList && skillViewFlg && data.sel_Endresult === '2') {
			data.scoresList.forEach((ele, index) => {
				if (!InputCheck.IsIntLessMaxOrBlank(ele.scores)) {
					const message: IMessage = {
						content: 'CHK_E_0014',
						replacements: [
							'「' +
								i18n.t('ActResultApplication_0021') +
								(index + 1) +
								'」',
							'2147483647',
						],
					};
					messages.push(message);
				}
			});
		}
		// 文字列最大値チェック
		if ((skillViewFlg && data.sel_Endresult === '2') || !skillViewFlg) {
			if (
				data.studentCareerCode &&
				InputCheck.chkStringMaxLength(data.studentCareerCode, 64)
			) {
				const message: IMessage = {
					content: 'CHK_E_0004',
					replacements: [i18n.t('ActResultApplication_0022'), '64'],
				};
				messages.push(message);
			}
		}
		if (data.comment && InputCheck.chkStringMaxLength(data.comment, 1000)) {
			const message: IMessage = {
				content: 'CHK_E_0004',
				replacements: [i18n.t('ActResultApplication_0027'), '1000'],
			};
			messages.push(message);
		}

		// 表示
		if (messages.length !== 0) {
			this.setState({
				messages,
				openErrorMessageDialog: true,
			});
			return false;
		} else {
			return true;
		}
	}

	/**
	 * 保存
	 * @param event イベントオブジェクト
	 */
	protected save(event: React.MouseEvent<HTMLElement>) {
		const applyFlg = false;
		if (!this.check(applyFlg)) {
			return;
		}
		const { token, data, userAttr } = this.props;
		const { careerID, classID, skillViewFlg } = this.state;
		if (skillViewFlg) {
			let form = null;
			if (this.uploadForm) {
				form = new FormData(this.uploadForm);
			} else {
				form = new FormData();
			}
			const arg: ISaveActResultApplicationParam = {
				application: data,
				applyFlg,
				careerID,
				classID,
				userAttr,
			};
			const convData = JSON.parse(JSON.stringify(arg.application));
			const modelData = {
				per_imstat_ActResApBlockModel: {
					accessType: '10',
					actionKind: 'update',
					applyFlg: arg.applyFlg,
					careerID: arg.careerID,
					classID: arg.classID,
					lang: arg.userAttr.lang,
					locale: arg.userAttr.locale,
					userId: arg.userAttr.userId,
					...convData,
				},
			};
			form.append('__modelData', JSON.stringify(modelData));
			const request = new XMLHttpRequest();
			request.open(
				'POST',
				Config.tsqPath + '/tsq/ui/common/resources/rest/file/upload',
				true
			);
			request.setRequestHeader('Accept', 'application/json');
			request.onreadystatechange = () => {
				if (request.readyState === 4 && request.status === 200) {
					const errorModel = JSON.parse(request.responseText);
					let errorCode = '';
					let replacements: string[] = [];
					if (
						errorModel.per_imstat_ActResApBlockModel !== undefined
					) {
						errorCode =
							errorModel.per_imstat_ActResApBlockModel.errorCode;
						replacements =
							errorModel.per_imstat_ActResApBlockModel
								.replacements;
					}
					if (errorModel.tsqErrorMessage !== undefined) {
						errorCode = errorModel.tsqErrorMessage[0].message;
						replacements = errorModel.tsqErrorMessage[0].strArray;
					}
					if (errorCode && errorCode !== '') {
						const messages: IMessage[] = [];
						const message: IMessage = {
							content: errorCode,
							replacements,
						};
						messages.push(message);
						this.setState({
							messages,
							openErrorMessageDialog: true,
						});
					} else {
						this.props.showActResultApplication(arg.applyFlg);
					}
				}
			};
			request.send(form);
		} else {
			this.props.saveActResultApplication(token, {
				application: data,
				applyFlg,
				careerID,
				classID,
				userAttr,
			});
		}
	}

	/**
	 * 実績確定
	 * @param event イベントオブジェクト
	 */
	protected commit(event: React.MouseEvent<HTMLElement>) {
		const applyFlg = true;
		if (!this.check(applyFlg)) {
			return;
		}

		const { token, data, userAttr } = this.props;
		const { careerID, classID, skillViewFlg } = this.state;

		if (skillViewFlg) {
			let form = null;
			if (this.uploadForm) {
				form = new FormData(this.uploadForm);
			} else {
				form = new FormData();
			}
			const arg: ISaveActResultApplicationParam = {
				application: data,
				applyFlg,
				careerID,
				classID,
				userAttr,
			};
			const convData = JSON.parse(JSON.stringify(arg.application));
			const modelData = {
				per_imstat_ActResApBlockModel: {
					accessType: '10',
					actionKind: 'update',
					applyFlg: arg.applyFlg,
					careerID: arg.careerID,
					classID: arg.classID,
					lang: arg.userAttr.lang,
					locale: arg.userAttr.locale,
					userId: arg.userAttr.userId,
					...convData,
				},
			};
			form.append('__modelData', JSON.stringify(modelData));
			const request = new XMLHttpRequest();
			request.open(
				'POST',
				Config.tsqPath + '/tsq/ui/common/resources/rest/file/upload',
				true
			);
			request.setRequestHeader('Accept', 'application/json');
			request.send(form);
			request.onreadystatechange = () => {
				if (request.readyState === 4 && request.status === 200) {
					const errorModel = JSON.parse(request.responseText);
					let errorCode = '';
					let replacements: string[] = [];
					if (
						errorModel.per_imstat_ActResApBlockModel !== undefined
					) {
						errorCode =
							errorModel.per_imstat_ActResApBlockModel.errorCode;
						replacements =
							errorModel.per_imstat_ActResApBlockModel
								.replacements;
					}
					if (errorModel.tsqErrorMessage !== undefined) {
						errorCode = errorModel.tsqErrorMessage[0].message;
						replacements = errorModel.tsqErrorMessage[0].strArray;
					}
					if (errorCode && errorCode !== '') {
						const messages: IMessage[] = [];
						const message: IMessage = {
							content: errorCode,
							replacements,
						};
						messages.push(message);
						this.setState({
							messages,
							openErrorMessageDialog: true,
						});
					} else {
						this.props.showActResultApplication(arg.applyFlg);
					}
				}
			};
		} else {
			this.props.saveActResultApplication(token, {
				application: data,
				applyFlg,
				careerID,
				classID,
				userAttr,
			});
		}
	}

	/**
	 * リセット
	 * @param event イベントオブジェクト
	 */
	protected reset(event: React.MouseEvent<HTMLElement>) {
		const { backup } = this.props;
		const scoresList: IScores[] = [];
		if (backup.scoresList) {
			backup.scoresList.forEach((item: IScores) => {
				const temp: IScores = {
					scoreID: item.scoreID,
					scoreName: item.scoreName,
					scores: Object.assign('', item.scores),
				};
				scoresList.push(temp);
			});
		}
		const newData: IActResultApplication = Object.assign(
			{},
			JSON.parse(JSON.stringify(backup))
		);
		newData.scoresList = scoresList;
		this.props.setActResultApplicationData(newData);
	}
}

const mapStateToProps = (state: IRootState) => ({
	backup: state.imstat.actResultApplication.backup,
	data: state.imstat.actResultApplication.data,
	openApplySuccessDialog:
		state.imstat.actResultApplication.openApplySuccessDialog,
	openSaveSuccessDialog:
		state.imstat.actResultApplication.openSaveSuccessDialog,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchActResultApplicationData: (
		token: string,
		arg: IFetchActResultApplicationDataParam
	) => {
		const s = ScenarioFactory.createFetchActResultApplicationData(
			dispatch,
			token
		);
		s.run(arg);
	},
	onClose: () =>
		dispatch(
			showActResultApplicationDialog({
				applySuccessDialogOpen: false,
				saveSuccessDialogOpen: false,
			})
		),
	pushHistory: (path: string) => dispatch(push(path)),
	saveActResultApplication: (
		token: string,
		arg: ISaveActResultApplicationParam
	) => {
		const s = ScenarioFactory.createSaveActResultApplication(
			dispatch,
			token
		);
		s.run(arg);
	},
	setActResultApplicationData: (data: IActResultApplication) =>
		dispatch(setActResultApplicationData({ data })),

	showActResultApplication: (applyFlg: boolean) => {
		dispatch(
			showActResultApplicationDialog({
				applySuccessDialogOpen: applyFlg,
				saveSuccessDialogOpen: !applyFlg,
			})
		);
	},
});

// tslint:disable-next-line: no-empty-interface
export interface IImstatActResultApplicationProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	IImstatActResultApplicationProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ImstatActResultApplication);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<IImstatActResultApplicationProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/ActResultApplication.tsx